"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const authored_columns_1 = require("../../../../composite/evidence/authored-evidence/authored-columns");
const table_cells_1 = require("../../../../composite/table/table-cells");
const table_filter_cells_1 = require("../../../../composite/table/table-filter-cells");
const ess_api_1 = require("../../ess-api");
function useColumns() {
    const intl = (0, react_intl_1.useIntl)();
    const { authoredColumns } = (0, authored_columns_1.useAuthoredColumns)();
    return [
        {
            datakey: 'number',
            name: intl.formatMessage({
                id: 'ESS_INCOMING_BATCHES_COLUMN_ORDER',
                defaultMessage: 'Pořadí',
            }),
            width: 100,
            CellComponent: table_cells_1.TableCells.NumberCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'state',
            sortkey: 'state.name',
            filterkey: 'state.id',
            name: intl.formatMessage({
                id: 'ESS_INCOMING_BATCHES_COLUMN_STATE',
                defaultMessage: 'Stav',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(ess_api_1.useIncomingBatchStates),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(ess_api_1.useIncomingBatchStates),
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'creationDate',
            name: intl.formatMessage({
                id: 'ESS_INCOMING_BATCHES_COLUMN_CREATION_DATE',
                defaultMessage: 'Datum vzniku',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.DateTimeCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'processedDate',
            name: intl.formatMessage({
                id: 'ESS_INCOMING_BATCHES_COLUMN_PROCESSED_DATE',
                defaultMessage: 'Datum zpracování',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.DateTimeCell,
            sortable: true,
            filterable: true,
        },
        ...authoredColumns,
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=batches-columns.js.map